// extracted by mini-css-extract-plugin
export default {"clock":"Clock_clock__Gn--N","dateWrapper":"Clock_dateWrapper__fO8P4","dateFull":"Clock_dateFull__1Xd7c","dateShort":"Clock_dateShort__OG87n","dateInput":"Clock_dateInput__Oemr1"};